
<div class="Vert-15"></div>
<div class="container">

    <form [formGroup]="_form" *ngIf="IsReady">

        <div class="row">
            <mat-form-field appearance="outline" floatLabel="always">
                <mat-label>Purchase Price</mat-label>
                <input type="number" matInput formControlName="purchasePrice">
            </mat-form-field>

            <mat-form-field appearance="outline" floatLabel="always">
                <mat-label>Interest Rate</mat-label>
                <input type="number" matInput formControlName="interestRate">
            </mat-form-field>


            <mat-form-field appearance="outline" floatLabel="always">
                <mat-label>Current Balance</mat-label>
                <input type="number" matInput formControlName="estimatedBalance">
            </mat-form-field>

            <mat-form-field appearance="outline" floatLabel="always">
                <mat-label>Other Loan Balance</mat-label>
                <input type="number" matInput formControlName="otherLoanBalance">
            </mat-form-field>

        </div>
    </form>


</div>
<div class="Vert-15"></div>

<lgv-loading-indicator *ngIf="!IsReady"></lgv-loading-indicator>

